<div
  *ngIf="visible"
  class="fullscreen-overlay"
  (click)="onOverlayClick($event)"
>
  <div class="fullscreen-dialog">
    <button class="close-btn" (click)="onClose()">×</button>
    <ng-content></ng-content>
  </div>
</div>
